const { initDatadogRum } = (function createDatadogRumInit() {
  let initialized = false;

  async function initDatadogRum(): Promise<void> {
    try {
      if (typeof window === "undefined") {
        return;
      }
      if (initialized) {
        return;
      }

      const applicationId = process.env.DATADOG_RUM_APPLICATION_ID || "";
      const clientToken = process.env.DATADOG_RUM_CLIENT_TOKEN || "";

      if (!applicationId || !clientToken) {
        return;
      }

      const enabled = (process.env.DATADOG_RUM_ENABLED || "true").toLowerCase();
      if (enabled !== "true" && enabled !== "1") {
        return;
      }

      const { datadogRum } = await import("@datadog/browser-rum");
      const { reactPlugin } = await import("@datadog/browser-rum-react");

      const service = process.env.DATADOG_RUM_SERVICE || "auto-buy-journey";
      const envName = process.env.DATADOG_RUM_ENV || "uat"
      const version = process.env.DATADOG_RUM_VERSION || "unknown"

      datadogRum.init({
        applicationId,
        clientToken,
        site: process.env.DATADOG_RUM_SITE || "datadoghq.com",
        service,
        env: envName,
        version,
        sessionSampleRate: 20,
        sessionReplaySampleRate: 0,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
        plugins: [reactPlugin({ router: false })]
      });

      initialized = true;
    } catch (error) {
        console.error("[Datadog RUM] initialization failed", error);
    }
  }

  return { initDatadogRum };
})();

export { initDatadogRum };
